import createAction from '@clearscore/helpers.create-action';
import createRequestPayload from '@clearscore/helpers.create-request-payload';

import { TRANSACTIONS_FETCH, TRANSACTIONS_AUTH, TRANSACTIONS_UPDATE } from './transactions.types';

// TRANSACTIONS_UPDATE
export const update = () =>
    createAction(TRANSACTIONS_UPDATE, createRequestPayload('banking', '/fetch/@profile.data.uuid'));

// TRANSACTIONS_FETCH
export const fetch = () => createAction(TRANSACTIONS_FETCH, createRequestPayload('banking', '/data/transactions'));

// START AUTH FLOW
export const authorise = (provider) =>
    createAction(TRANSACTIONS_AUTH, createRequestPayload('banking', '/auth/tl', 'post', provider));
